import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RStatus } from "features/Application/types";
import { type ContentItem } from "features/AssetResults/types";

interface RecentCoursesState {
  status: RStatus;
  error: string | null;
  items: ContentItem[];
}

export const initialState: RecentCoursesState = {
  status: RStatus.Pending,
  error: null,
  items: [],
};

const slice = createSlice({
  name: "homeRecentCourses",
  initialState,
  reducers: {
    req(state) {
      state.status = RStatus.Pending;
    },
    got(state, action: PayloadAction<ContentItem[]>) {
      state.status = RStatus.Got;
      state.items = action.payload;
    },
    err(state, action: PayloadAction<string>) {
      state.status = RStatus.Error;
      state.error = action.payload;
    },
    reset() {
      return initialState;
    },
  },
});

export const { err, got, req, reset } = slice.actions;

export default slice.reducer;
